import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  TableSummary,
  TableSummaryResponse,
} from '../models/table-summary.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AdminTableSummaryService {
  private readonly apiService = inject(ApiService);

  getVoiceToVoiceTranscriptSummary(): Observable<TableSummary> {
    return this.getTableSummary(
      'admin/get-voice2voice-transcripts-total-number'
    );
  }

  private getTableSummary(endpoint: string): Observable<TableSummary> {
    // Intentionally pass no options: these endpoints accept no query params or body.
    return this.apiService.get<TableSummaryResponse>(endpoint).pipe(
      map((response) => ({
        totalItems: response.totalItems,
        tableSizeBytes: response.tableSizeBytes,
        tableStatus: response.tableStatus,
        createdAt: response.tableInfo?.creationDateTime,
      }))
    );
  }
}
